import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../i18n/LanguageContext';
import './Footer.css';

const Footer: React.FC = () => {
  const { t } = useLanguage();

  return (
    <footer id="footer">
      <div className="footer-grid">
        <div className="footer-brand">
          <div className="footer-logo">MSL</div>
          <p>{t.footer.desc}</p>
        </div>
        <div className="footer-col">
          <h4>{t.footer.explore}</h4>
          <Link to="/about">{t.nav.about}</Link>
          <Link to="/ecosystem">{t.nav.ecosystem}</Link>
          <Link to="/team">{t.nav.team}</Link>
          <Link to="/technology">{t.nav.technology}</Link>
        </div>
        <div className="footer-col">
          <h4>{t.footer.ecosystem}</h4>
          <a href="#ecosystem">{t.footer.base}</a>
          <a href="#ecosystem">{t.footer.aggregation}</a>
          <a href="#ecosystem">{t.footer.finance}</a>
          <a href="#ecosystem">{t.footer.entertainment}</a>
        </div>
        <div className="footer-col">
          <h4>{t.footer.contact}</h4>
          <a href="#">contact@msl.space</a>
          <a href="https://x.com/metachainclub" target="_blank" rel="noreferrer">Twitter / X</a>
          <a href="#">Discord</a>
          <a href="#">GitHub</a>
        </div>
      </div>
      <div className="footer-bottom">
        <span>{t.footer.copyright}</span>
        <div className="footer-social">
          <a href="https://x.com/metachainclub" target="_blank" rel="noreferrer" title="Twitter">𝕏</a>
          <a href="#" title="Discord">●</a>
          <a href="#" title="GitHub">○</a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
